import { render } from "./workflowsTable.vue?vue&type=template&id=1db7b253"
import script from "./workflowsTable.vue?vue&type=script&lang=js"
export * from "./workflowsTable.vue?vue&type=script&lang=js"

import "./workflowsTable.vue?vue&type=style&index=0&id=1db7b253&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__